import { useEffect, useState } from 'react';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectOverviewDto } from '../../../commonTypes/acs';
import { DateTime } from 'luxon';

const useHttpGetProjectOverviewOnMount = (projectId: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isProjectOverviewReady, setProjectOverviewReady] = useState(false);
    const [data, setData] = useState<ProjectOverviewDto[]>([]);

    useEffect(() => {
        const from = encodeURIComponent(DateTime.now().startOf('month').toISO());
        const to = encodeURIComponent(DateTime.now().endOf('month').toISO());
        const { exec, abort } = acsApi.getProjectOverview({
            params: { projectId },
            query: { from, to, page: 0, size: 4 },
            onSuccess: res => setData(res.body),
            onError: error => console.log(error),
            onFinally: () => setProjectOverviewReady(true),
        });
        exec();
        return abort;
    }, [projectId]);
    return { isProjectOverviewReady, data };
};

export default useHttpGetProjectOverviewOnMount;
